import React, { useState } from "react";
import { LANGUAGES } from "@/i18n/translations";
import { useI18n } from "@/context/LanguageContext";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher-btn"
          className="inline-flex items-center gap-2 px-3 py-2 border border-[color:var(--border)] hover:border-[color:var(--border-strong)] bg-[color:var(--surface)] text-[color:var(--text)] text-sm font-mono transition-colors rounded"
        >
          <Globe className="w-4 h-4 text-[color:var(--brand)]" />
          <span className="tracking-wider">{current.flag}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[color:var(--surface)] border-[color:var(--border)] text-[color:var(--text)] min-w-[200px]"
        data-testid="language-switcher-menu"
      >
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between cursor-pointer hover:bg-[color:var(--surface-2)] focus:bg-[color:var(--surface-2)] px-3 py-2"
          >
            <span className="flex items-center gap-3">
              <span className="font-mono text-xs text-[color:var(--brand)] w-6">{l.flag}</span>
              <span className="text-sm">{l.label}</span>
            </span>
            {l.code === lang && <Check className="w-4 h-4 text-[color:var(--brand)]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
